var CheckoutPage = {};

CheckoutPage.billingFields = [
  {name: "billingFirstName", required: true},
  {name: "billingLastName", required: true},
  {name: "billingEmail", required: true},
  {
    name: "billingPhone", required: true, regexp: function (input, form) {
      var phone = input.value.replace(/-|\s+/g, "");
      if (input.value && !/^(\+[0-9]{2})*[0-9]{9}$/g.test(phone)) {
        return false;
      }
      return true;
    }
  },
  {name: "billingStreet", required: true},
  {name: "billingHouseNumber", required: true},
  {
    name: "billingZip", required: true, regexp: function (input, form) {
      var postcode = input.value.replace(/\s+/g, "");
      if (postcode && !/^[0-9]{2}-[0-9]{3}$/g.test(postcode)) {
        return false;
      }
      return true;
    }
  },
  {name: "billingCity", required: true},
  {
    name: "billingVatID", required: function (input, form) {
      if (form.elements.hasInvoice.checked && !input.value) {
        return false;
      }
      return true;
    }
  },
];

CheckoutPage.deliveryFields = [
  {name: "deliveryFirstName", required: true},
  {name: "deliveryLastName", required: true},
  {
    name: "deliveryPhone", required: true, regexp: function (input, form) {
      var phone = input.value.replace(/-|\s+/g, "");
      if (input.value && !/^(\+[0-9]{2})*[0-9]{9}$/g.test(phone)) {
        return false;
      }
      return true;
    }
  },
  {name: "deliveryStreet", required: true},
  {name: "deliveryHouseNumber", required: true},
  {
    name: "deliveryZip", required: true, regexp: function (input, form) {
      var postcode = input.value.replace(/\s+/g, "");
      if (postcode && !/^[0-9]{2}-[0-9]{3}$/g.test(postcode)) {
        return false;
      }
      return true;
    }
  },
  {name: "deliveryCity", required: true}
];

CheckoutPage.init = function () {


  if (!document.forms.checkoutDelivery) {
    return;
  }

  CheckoutPage.fields = document.forms.checkoutDelivery.elements;

  InpostMap.init(".with-map", {
    initValue: CheckoutPage.fields.postbox.value
  });

  $('#hasInvoice').change(CheckoutPage.toggleToInvoice);
  $('#addDeliveryAddress a').click(CheckoutPage.addDeliveryAddress);
  $('#removeDeliveryAddress a').click(CheckoutPage.removeDeliveryAddress);
  CheckoutPage.isInvoice = $('#hasInvoice').prop("checked");
  $('button[type=submit]').click(function (event) {
    var errors = CheckoutPage.validateForm();
    if (errors.length) {
      event.preventDefault();
    }
  });
  $('select').select2();
  $('[name="deliveryMethod"]').change(function (input) {
    CheckoutPage.onDeliveryMethodChange({
      _id: input.currentTarget.value,
      sysName: input.currentTarget.dataset.system,
      paymentMethods: JSON.parse(input.currentTarget.dataset.payments)
    });
  });
};

/**
 * Returns null or value of a selected radio button from a given radio buttons set
 * @param buttons
 * @returns {null|*}
 */
CheckoutPage.getValueFromRadioButton = function (buttons) {
  for (var i = 0; i < buttons.length; i++) {
    var button = buttons[i];
    if (button.checked) {
      return button.value;
    }
  }
  return null;
};

CheckoutPage.validateForm = function () {
  var form = document.forms.checkoutDelivery;
  var errors = Forms.validateFields(form, CheckoutPage.billingFields);
  if (CheckoutPage.hasDiliveryAddress) {
    Forms.validateFields(form, CheckoutPage.deliveryFields, errors);
  }
  var deliveryMethod = this.getValueFromRadioButton(form.elements.deliveryMethod);
  var paymentMethod = this.getValueFromRadioButton(form.elements.paymentMethod);
  if (!deliveryMethod || !paymentMethod) {
    errors.length++;
    errors.deliveryMethod = {required: true};
    $('[data-for="deliveryMethod"][data-kind="required"]').show();
  } else {
    $('[data-for="deliveryMethod"][data-kind="required"]').hide();
  }
  if (deliveryMethod && $('#' + deliveryMethod).data("system") === "inpost_postbox" && !form.postbox.value) {
    errors.length++;
    errors.postbox = {required: true};
    $('[data-for="postbox"][data-kind="required"]').show();
  } else {
    $('[data-for="postbox"][data-kind="required"]').hide();
  }
  return errors;
};

CheckoutPage.onDeliveryMethodChange = function (deliveryMethod) {
  $('#paymentMethods input').prop('checked', false);
  if (deliveryMethod.paymentMethods && deliveryMethod.paymentMethods.length) {
    $('#paymentMethods').show();
    $('#paymentMethods label').hide();
    deliveryMethod.paymentMethods.forEach(function (method) {
      $('[for="' + method._id + '"]').show();
    });
  } else {
    $('#paymentMethods').hide();
  }
  if (deliveryMethod.sysName === "manual") {
    $('.with-warehouse').show();
  } else {
    $('.with-warehouse').hide();
  }
  if (deliveryMethod.sysName === "inpost_postbox") {
    if (CheckoutPage.hasDiliveryAddress && CheckoutPage.fields.deliveryCity.value) {
      InpostMap.show({address: CheckoutPage.fields.deliveryCity.value});
    } else if (CheckoutPage.fields.billingCity.value) {
      InpostMap.show({address: CheckoutPage.fields.billingCity.value});
    } else {
      InpostMap.show();
    }
  } else {
    InpostMap.hide();
    $('.with-map').hide();
  }
};

CheckoutPage.toggleToInvoice = function () {
  if (CheckoutPage.isInvoice) {
    $(CheckoutPage.fields.billingCompanyName).parent().hide();
    $(CheckoutPage.fields.billingVatID).parent().hide();
  } else {
    $(CheckoutPage.fields.billingCompanyName).parent().show();
    $(CheckoutPage.fields.billingVatID).parent().show();
  }
  CheckoutPage.isInvoice = !CheckoutPage.isInvoice;
};

CheckoutPage.addDeliveryAddress = function () {
  CheckoutPage.hasDiliveryAddress = true;
  $('#deliverySection').show();
  $('#addDeliveryAddress').hide();
  $('#deliveryCompanyName').focus();
  $('html, body').animate({
    scrollTop: $("#deliverySection").offset().top
  }, 1000);
  document.forms.checkoutDelivery.elements.hasDeliveryAddress.value = true;
};

CheckoutPage.removeDeliveryAddress = function () {
  CheckoutPage.hasDiliveryAddress = false;
  document.forms.checkoutDelivery.elements.hasDeliveryAddress.value = false;
  $('#deliverySection').hide();
  $('#addDeliveryAddress').show();
};


var InpostMap = {};

InpostMap.init = function (selector, options) {
  InpostMap.$el = $(selector);
  InpostMap.markers = [];
  var mapOptions = {
    zoom: 13,
    center: new google.maps.LatLng(52.2297, 21.0122), // wawa
  };
  var mapElement = InpostMap.$el.find('#map_1').get(0);
  // Create the Google Map using our element and options defined above
  InpostMap.map = new google.maps.Map(mapElement, mapOptions);

  $('#inpostSearch').on("keydown", function (event) {
    if (event.which === 13) {
      event.preventDefault();
    }
    if (event.currentTarget.value.length > 3) {
      Inpost.searchPostBoxes({address: event.currentTarget.value}, InpostMap.onInpostSearchResults);
    }
  });

  if (options.initValue) {
    try {
      var postbox = typeof options.initValue === "object" ? options.initValue : JSON.parse(options.initValue);
      InpostMap.results = {
        count: 1,
        items: [postbox]
      };
      InpostMap.updateInpostBoxes();
      InpostMap.updateMarkers();
      InpostMap.map.setCenter({lat: postbox.location.latitude, lng: postbox.location.longitude});
      InpostMap.map.setZoom(17);
      $('#inpostPostBoxesList').select2().val(postbox.name);
    } catch (e) {
      //silent
    }
  }
};

InpostMap.onInpostSearchResults = function (results) {
  if (results && results.count > 0) {
    results.items = results.items.sort(function (a, b) {
      if (a.address.line1.toLowerCase() < b.address.line1.toLowerCase()) {
        return -1;
      }
      if (b.address.line1.toLowerCase() < a.address.line1.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    InpostMap.results = results;
    InpostMap.centerMap(results.items[0].location);
  }
  InpostMap.results = results;
  InpostMap.updateInpostBoxes();
  InpostMap.updateMarkers();
  InpostMap.$el.show();
};

InpostMap.updateInpostBoxes = function () {
  var $select = $('#inpostPostBoxesList');
  if (InpostMap.results && InpostMap.results.count > 0) {
    $('#inpostPostBoxes').show();
    if ($select.hasClass("select2-hidden-accessible")) {
      $select.select2("destroy");
    }
    $select.find('option').remove();
    $select.append("<option></option>");
    $select.select2().on('select2:select', function (e) {
      for (var mi = 0; mi < InpostMap.markers.length; mi++) {
        if (InpostMap.markers[mi].postbox === e.params.data.id) {
          InpostMap.map.setZoom(17);
          InpostMap.map.panTo(InpostMap.markers[mi].marker.position);
          var item = InpostMap.results.items.filter(function (item) {
            return item.name === e.params.data.id;
          });
          InpostMap.setPostbox(item[0]);
          break;
        }
      }
    });
    InpostMap.results.items.forEach(function (item) {
      var newOption = new Option(item.address.line1 + " " + item.address.line2 + " (" + item.name + ")", item.name, false, false);
      $select.select2().append(newOption).trigger('change');
    });
  }
};

InpostMap.updateMarkers = function () {
  if (InpostMap.results && InpostMap.results.count > 0) {
    InpostMap.markers.forEach(function (marker) {
      marker.marker.setMap(null);
    });
    InpostMap.markers.length = 0;
    InpostMap.results.items.forEach(function (item) {
      var marker = new google.maps.Marker({
        position: {lat: item.location.latitude, lng: item.location.longitude},
        map: InpostMap.map,
        title: item.name
      });
      var infoWindow = new google.maps.InfoWindow({
        content: '<div id="content">' +
          '<h4 id="firstHeading" class="firstHeading">' + item.name + '</h4>' +
          '<div id="bodyContent">' +
          '<p>' + item.address.line1 + '<br/>' + item.address.line2 + '</p>' +
          '</div></div>'
      });
      marker.addListener('mouseover', function () {
        infoWindow.open(CheckoutPage.map, marker);
      });
      marker.addListener('mouseout', function () {
        infoWindow.close();
      });
      marker.addListener('click', function () {
        InpostMap.map.setZoom(17);
        InpostMap.map.setCenter(marker.getPosition());
        InpostMap.setPostbox(item);
        $('#inpostPostBoxesList').val(item.name).trigger('change');
      });

      InpostMap.markers.push({
        postbox: item.name,
        info: infoWindow,
        marker: marker
      });
    });
  }
};

InpostMap.setPostbox = function (item) {
  $('[name="postbox"]').val(JSON.stringify({name: item.name, location: item.location, address: item.address}));
};

InpostMap.show = function (options) {
  if (options && options.address) {
    Inpost.searchPostBoxes(options, function (results) {
      InpostMap.onInpostSearchResults(results);
      InpostMap.$el.show();
    });
  } else {
    InpostMap.$el.show();
  }
};

InpostMap.hide = function () {
  InpostMap.$el.hide();
};

InpostMap.centerMap = function (coords) {
  InpostMap.map && InpostMap.map.setCenter({lat: coords.latitude, lng: coords.longitude});
};

$(CheckoutPage.init);
